<template>
  <div
    v-if="isVisible"
    class="fe-fixed fe-top-0 fe-left-0 fe-h-full fe-w-full fe-z-[50] fe-block"
  >
    <div
      class="fe-top-0 fe-left-0 fe-bottom-0 fe-w-full fe-z-[60] fe-fixed fe-bg-primary-grey-80 fe-transition-all fe-duration-300"
      @click="handleClose"
    ></div>
    <div
      class="fe-w-full lg:fe-max-w-[412px] fe-h-full fe-ml-auto fe-flex fe-relative fe-z-[60] fe-transition-all fe-duration-300 fe-shadow-m"
      :class="backgroundClass"
      @click.stop
    >
      <div class="fe-flex fe-flex-col justify-between fe-w-full fe-h-auto">
        <div
          v-if="$slots.header"
          class="fe-flex fe-items-center fe-text-heading-xs lg:fe-justify-between lg:fe-px-m lg:fe-pt-m sm:fe-bg-primary-50 sm:fe-h-huge sm:fe-text-body-s sm:fe-text-white sm:fe-px-s sm:fe-py-xs"
        >
          <div class="lg:fe-hidden">
            <JdsButton
              @click="handleClose"
              :icon-only="true"
              variant="tertiary"
            >
              <template #icon>
                <JdsIcon
                  name="ChevronLeftIcon"
                  size="m"
                  color="fe-text-white"
                />
              </template>
            </JdsButton>
          </div>

          <slot name="header"></slot>

          <div class="sm:fe-hidden">
            <JdsButton
              @click="handleClose"
              :icon-only="true"
              variant="tertiary"
            >
              <template #icon>
                <JdsIcon name="CloseIcon" size="m" color="fe-text-primary-60" />
              </template>
            </JdsButton>
          </div>
        </div>
        <div
          class="fe-flex fe-flex-col fe-flex-1 fe-overflow-y-auto fe-no-scrollbar"
          :class="removeHorizontalClass ? '' : 'fe-px-m'"
        >
          <slot name="body"></slot>
        </div>
        <div
          class="fe-w-full fe-py-base fe-bg-white fe-shadow-m fe-px-m"
          v-if="$slots.footer"
        >
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import JdsButton from "@/components/DesignSystem/JdsButton/JdsButton.vue"
  import JdsIcon from "@/components/DesignSystem/JdsIcon/JdsIcon.vue"

  export default {
    name: "JdsSidePanel",
    components: {
      JdsButton,
      JdsIcon,
    },
    props: {
      /* 
      This prop (isVisible) is must for Vue to track the component reactivity. 
      But we don't want to create any new state variable in every other component to track this value in most of the cases, because the way we have designed ModalRegistry component.
      Basically when you use this.openModal(), Modal will be visible and if you don't want to add any operation when modal closes, you don't need to use this.closeModal(), since in ModalRegistry, we are already listening for @close event which close the modal.
      And if you do want to use this.closeModal(), you can do that also.
      So that's why we have kept the default value as TRUE.
    */
      isVisible: {
        type: Boolean,
        default: true,
      },
      // This prop is being used to remove horizontal padding from body section. So that user can add their own padding.
      // Header and Footer padding won't be removed in this case
      removeHorizontalClass: {
        type: Boolean,
        default: false,
        required: false,
      },
      backgroundClass: {
        type: String,
        default: "fe-bg-white",
        required: false,
      },
    },
    methods: {
      handleClose() {
        this.$emit("close")
      },
    },
  }
</script>
